import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import { usePopper } from "react-popper";
import useOutsideDetector from "../../hooks/useOutsideDetector";

const dateUtil = require("../../utils/dateUtil/dateUtil");

function DatePicker(
    {
        value,
        innerRef,
        isOpen,
        placement = "bottom",
        onChange = () => { },
        onOutSideClick = () => { },
    }
)
{
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(innerRef.current, popperElement, { placement: placement });
    const dialogStyle = { ...styles.popper, zIndex: '1' }
    const selectedDate = dateUtil.isValidDateOrDateTime(value) ? new Date(value) : undefined;

    const handleOutsideClick = function (e)
    {
        if (innerRef && innerRef.current && !innerRef.current.contains(e.target))
        {
            onOutSideClick();
        }
    }

    useOutsideDetector({ current: popperElement }, handleOutsideClick)

    const handleDateChange = (date) =>
    {
        if (date instanceof Date)
        {
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let dayOfMonth = date.getDate();
            month = month < 10 ? ('0' + month) : ('' + month);
            dayOfMonth = dayOfMonth < 10 ? ('0' + dayOfMonth) : ('' + dayOfMonth);
            date = [year, month, dayOfMonth].join("-");
            onChange(date);
        }
        else 
        {
            onChange(null);
        }
    }

    if (isOpen)
    {
        return (
            <div
                className="dialog-sheet"
                ref={setPopperElement}
                style={dialogStyle}
                role="dialog"
                aria-label="Date picker"
                {...attributes.popper}
            >
                <DayPicker
                    initialFocus={isOpen}
                    mode="single"
                    defaultMonth={selectedDate}
                    selected={selectedDate}
                    onSelect={handleDateChange}
                />
            </div>
        )
    }
}

export default DatePicker;
